// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".validation-error-text{color:var(--text-error);font-weight:bold}", "",{"version":3,"sources":["webpack://./acisHorizon/assets/vue/components/modals/ModalManager.vue"],"names":[],"mappings":"AACA,uBACI,uBAAA,CACA,gBAAA","sourcesContent":["\n.validation-error-text {\n    color: var(--text-error);\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
